__turbopack_context__.v({
  "color": "tG9XYa_color",
  "placedholderText": "tG9XYa_placedholderText",
  "textBar": "tG9XYa_textBar",
});
